module.exports = __webpack_public_path__ + "img/home-mailbox-bottom-img.b642c7fa.webp";